import { render, staticRenderFns } from "./CreateTask.vue?vue&type=template&id=2fad2874&scoped=true"
import script from "./CreateTask.vue?vue&type=script&lang=js"
export * from "./CreateTask.vue?vue&type=script&lang=js"
import style0 from "./CreateTask.vue?vue&type=style&index=0&id=2fad2874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fad2874",
  null
  
)

export default component.exports